import { default as answersInitialState } from 'reducers/answers/initialState';
import { default as configInitialState } from 'reducers/config/initialState';
import { default as mainInitialState } from 'reducers/main/initialState';
import { default as workflowsInitialState } from 'reducers/workflows/initialState';
import { default as liveChatInitialState } from 'reducers/live-chat/initialState';

const initialState = {
  answers: answersInitialState,
  config: configInitialState,
  liveChat: liveChatInitialState,
  main: mainInitialState,
  workflows: workflowsInitialState,
};

export default initialState;
